import $ from "jquery"

class Teaser {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("Teaser::initialize()")

		this.$teaserL = $(".bb-teaser.bb-teaser--type-l")
		this.$teaserS = $(".bb-teaser--type-s")
		this.$teaserM = $(".bb-teaser--type-m")
		this._initEvents()
		this._onResize()
	}

	_initEvents() {
		let resizeDone
		$(window).on("resize", () => {
			clearTimeout(resizeDone)
			resizeDone = setTimeout(this._onResize.bind(this), 100)
		})

		this.$teaserS.on(
			"mouseenter",
			".bb-teaser__backdrop, .bb-teaser__rating-container",
			this._onBackdropRatingHover,
		)
		this.$teaserS.on(
			"mouseleave",
			".bb-teaser__backdrop, .bb-teaser__rating-container",
			this._onBackdropRatingLeave,
		)
		this.$teaserM.on("mouseenter", this._onBackdropRatingHover)
		this.$teaserM.on("mouseleave", this._onBackdropRatingLeave)
	}

	_onResize() {
		this.$teaserL.each((i, teaser) => {
			if ($(teaser).find(".has-packshot").length) {
				const contentHeight = $(teaser).find(".bb-teaser__content-container").outerHeight()
				const imageBottom = $(teaser).find(".bb-teaser__packshot-image-container").css("bottom")
				const imageHeight = $(teaser).find(".bb-teaser__image-wrapper img").height() // - 10
				const maxHeight = imageHeight + contentHeight - parseInt(imageBottom) * 2

				$(teaser)
					.find(".has-packshot img")
					.css({ "max-height": maxHeight + "px" })
			}
		})
	}

	_onBackdropRatingHover(event) {
		const $image = $(event.currentTarget).closest(".bb-teaser").find(".bb-teaser__image")

		if ($image.hasClass("has-hover-animation")) {
			$image.addClass("hover")
		}
	}

	_onBackdropRatingLeave(event) {
		const $image = $(event.currentTarget).closest(".bb-teaser").find(".bb-teaser__image")

		if ($image.hasClass("has-hover-animation")) {
			$image.removeClass("hover")
		}
	}
}

export default Teaser
